var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("import-table", {
        ref: "table",
        attrs: { url: _vm.url },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _c("div", { staticClass: "dropdown d-inline" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary dropdown-toggle",
                      attrs: {
                        type: "button",
                        id: "dropdownImportMenuButton",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [_c("i", { staticClass: "far fa-file pr-2" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu compact",
                      attrs: { "aria-labelledby": "dropdownImportMenuButton" },
                    },
                    _vm._l(_vm.importOptions, function (item) {
                      return _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.addImport(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.title) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("filemaker-dialog"),
      _vm._v(" "),
      _c("do-not-contact-dialog"),
      _vm._v(" "),
      _c("stop-list-dialog"),
      _vm._v(" "),
      _c("filemaker-with-email-dialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }